import { FC, useState } from 'react';
import { WrapInLayout } from '../layouts';
import { orderApi } from '../api/order.api';
import OrdersCategoryList from '../components/orders/OrdersCategoryList';
import OrdersDrilldownModal from '../components/orders/OrdersDrilldownModal';
import { DRILLDOWN_BY_VEHICLE, SUMMARY_BY_VEHICLE } from '../components/orders/categoryColumns';
import { IDateRange, presetRange } from '../components/orders/orderDatePresets';

const OrdersByVehiclePage: FC = () => {
  const [range, setRange] = useState<IDateRange>(() => presetRange('month'));

  const { data, isFetching, isError, error } = orderApi.useGetOrdersByVehicleQuery({
    createdFrom: range.createdFrom,
    createdTill: range.createdTill,
  });

  return (
    <WrapInLayout title="Orders By Vehicle" layout="dashboard">
      <h1 className="text-xl font-semibold mb-3">Orders By Vehicle</h1>
      <OrdersCategoryList
        categoryTitle="vehicle"
        columns={SUMMARY_BY_VEHICLE}
        unit="vehicle(s)"
        resizeStorageKey="orders-by-vehicle"
        rows={data}
        isFetching={isFetching}
        isError={isError}
        error={error}
        range={range}
        onRangeChange={setRange}
        renderDrilldown={(row, close) => (
          <OrdersDrilldownModal
            title={`Orders for ${row.category}`}
            columns={DRILLDOWN_BY_VEHICLE}
            createdFrom={range.createdFrom}
            createdTill={range.createdTill}
            vehicle={row.category}
            onClose={close}
          />
        )}
      />
    </WrapInLayout>
  );
};

export default OrdersByVehiclePage;
